import { api } from '@/redux/api';
import { useCurrentUnit } from './use-current-unit';

export const useCurrentConnectivity = (page = 1, limit = 50) => {
  const { data: unit } = useCurrentUnit();

  const unitId = unit?.id ?? -1;

  return api.useGetConnectivityQuery(
    { unitId, page, limit },
    {
      skip: unitId === -1,
    },
  );
};
